module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.itemThemeNamespace = exports.withItemFocus = exports.withItemClick = exports.ItemGroup = exports.default = void 0;
    var _ItemGroup = __webpack_require__(2);
    Object.defineProperty(exports, "ItemGroup", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ItemGroup).default;
        }
    });
    var _withItemClick = __webpack_require__(13);
    Object.defineProperty(exports, "withItemClick", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_withItemClick).default;
        }
    });
    var _withItemFocus = __webpack_require__(20);
    Object.defineProperty(exports, "withItemFocus", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_withItemFocus).default;
        }
    });
    var _theme = __webpack_require__(11);
    Object.defineProperty(exports, "itemThemeNamespace", {
        enumerable: !0,
        get: function() {
            return _theme.themeNamespace;
        }
    });
    var _Item = __webpack_require__(23), _Item2 = _interopRequireDefault(_Item);
    exports.default = _Item2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _ItemGroup = __webpack_require__(8), ItemGroup = function(_Component) {
        function ItemGroup() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, ItemGroup);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [ this ].concat(args))), 
            _this.state = {
                ariaLabel: _this.props.title
            }, _this.componentDidMount = function() {
                (_this.props.title || _this.props.elemAfter) && _this.setState({
                    ariaLabel: _this.getAriaLabel()
                });
            }, _this.componentDidUpdate = function() {
                if (_this.props.title || _this.props.elemAfter) {
                    var ariaLabel = _this.getAriaLabel();
                    _this.state.ariaLabel !== ariaLabel && _this.setState({
                        ariaLabel: ariaLabel
                    });
                }
            }, _this.getAriaLabel = function() {
                var _this$props = _this.props, elemAfter = _this$props.elemAfter, title = _this$props.title, afterText = elemAfter && "string" == typeof elemAfter ? elemAfter : _this.headingAfterElement && _this.headingAfterElement.textContent;
                return "" + title + (afterText ? " " + String(afterText) : "");
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        // eslint-disable-next-line
        // eslint-disable-line react/sort-comp
        return (0, _inherits3.default)(ItemGroup, _Component), ItemGroup.prototype.render = function() {
            var _this2 = this, _props = this.props, children = _props.children, elemAfter = _props.elemAfter, isCompact = _props.isCompact, title = _props.title, innerRef = _props.innerRef, role = _props.role, ariaLabel = this.state.ariaLabel;
            return _react2.default.createElement("div", {
                "aria-label": ariaLabel,
                role: role,
                ref: innerRef
            }, title ? _react2.default.createElement(_ItemGroup.GroupTitle, {
                "aria-hidden": "true",
                isCompact: isCompact
            }, _react2.default.createElement(_ItemGroup.GroupTitleText, null, title), elemAfter ? _react2.default.createElement(_ItemGroup.GroupTitleAfter, {
                innerRef: function(r) {
                    return _this2.headingAfterElement = r;
                }
            }, elemAfter) : null) : null, children);
        }, ItemGroup;
    }(_react.Component);
    ItemGroup.propTypes = {
        /** Items to be shown inside the item group. */
        children: _propTypes2.default.node,
        /** Causes the group title to be rendered with reduced spacing. */
        isCompact: _propTypes2.default.bool,
        /** Optional heading text to be shown above the items. */
        title: _propTypes2.default.node,
        /** Content to be shown to the right of the heading */
        elemAfter: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.string ]),
        /** A function that returns the DOM ref created by the group */
        innerRef: _propTypes2.default.func,
        /** Accessibility role to be applied to the root component */
        role: _propTypes2.default.string
    }, ItemGroup.defaultProps = {
        role: "group"
    }, exports.default = ItemGroup;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 8 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.GroupTitleText = exports.GroupTitleAfter = exports.GroupTitle = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(9), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n    padding: ", "px ", "px ", "px ", "px;\n  " ], [ "\n    padding: ", "px ", "px ", "px ", "px;\n  " ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  ", "\n" ], [ "\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  ", "\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 0 0 auto;\n  margin-right: -", "px;\n" ], [ "\n  flex: 0 0 auto;\n  margin-right: -", "px;\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 1 1 auto;\n  font-size: ", "px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n" ], [ "\n  flex: 1 1 auto;\n  font-size: ", "px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(11), getPadding = function(_ref) {
        var isCompact = _ref.isCompact, theme = _ref.theme, paddingType = isCompact ? "compact" : "default", _getThemeStyle = (0, 
        _theme.getThemeStyle)(theme[_theme.themeNamespace], paddingType, "padding"), _getThemeStyle$bottom = _getThemeStyle.bottom, bottom = void 0 === _getThemeStyle$bottom ? 0 : _getThemeStyle$bottom, _getThemeStyle$left = _getThemeStyle.left, left = void 0 === _getThemeStyle$left ? 0 : _getThemeStyle$left, _getThemeStyle$right = _getThemeStyle.right, right = void 0 === _getThemeStyle$right ? 0 : _getThemeStyle$right, _getThemeStyle$top = _getThemeStyle.top, top = void 0 === _getThemeStyle$top ? 0 : _getThemeStyle$top;
        return (0, _styledComponents.css)(_templateObject, top, right, bottom, left);
    }, GroupTitle = _styledComponents2.default.div(_templateObject2, function(_ref2) {
        var theme = _ref2.theme;
        return (0, _theme.getThemeStyle)(theme[_theme.themeNamespace], "secondaryText", "default");
    }, getPadding);
    GroupTitle.displayName = "ItemGroupTitle";
    var GroupTitleAfter = _styledComponents2.default.div(_templateObject3, _theme.gridSize / 2);
    GroupTitleAfter.displayName = "ItemGroupTitleAfter";
    var GroupTitleText = _styledComponents2.default.div(_templateObject4, _theme.smallFontSize);
    GroupTitleText.displayName = "ItemGroupTitleText", exports.GroupTitle = GroupTitle, 
    exports.GroupTitleAfter = GroupTitleAfter, exports.GroupTitleText = GroupTitleText;
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getThemeStyle = exports.themeWithKeys = exports.defaultTheme = exports.gridSize = exports.compactLineHeight = exports.compactSmallFontSize = exports.smallFontSize = exports.themeNamespace = void 0;
    var _theme = __webpack_require__(12), defaultTheme = (exports.themeNamespace = "@atlaskit-shared-theme/item", 
    exports.smallFontSize = 12, exports.compactSmallFontSize = 10, exports.compactLineHeight = 1.2, 
    exports.gridSize = (0, _theme.gridSize)(), exports.defaultTheme = {
        afterItemSpacing: (0, _theme.gridSize)(),
        beforeItemSpacing: (0, _theme.gridSize)(),
        borderRadius: (0, _theme.borderRadius)(),
        focus: {
            outline: _theme.colors.B100
        },
        height: {
            compact: 0,
            default: 0
        },
        padding: {
            default: {
                bottom: (0, _theme.gridSize)() / 2,
                left: (0, _theme.gridSize)() / 2,
                right: (0, _theme.gridSize)() / 2,
                top: (0, _theme.gridSize)() / 2
            },
            compact: {
                bottom: (0, _theme.gridSize)(),
                left: (0, _theme.gridSize)(),
                right: (0, _theme.gridSize)(),
                top: (0, _theme.gridSize)()
            }
        },
        default: {
            background: _theme.colors.N0,
            text: _theme.colors.N500,
            secondaryText: _theme.colors.N200
        },
        selected: {
            background: _theme.colors.N0,
            text: _theme.colors.N500,
            secondaryText: _theme.colors.N200
        },
        active: {
            background: _theme.colors.B75,
            text: _theme.colors.N800,
            secondaryText: _theme.colors.N200
        },
        hover: {
            background: _theme.colors.N20,
            text: _theme.colors.N800,
            secondaryText: _theme.colors.N200
        },
        disabled: {
            background: _theme.colors.N0,
            text: _theme.colors.N200,
            secondaryText: _theme.colors.N200
        },
        // same as hover in this case
        dragging: {
            background: _theme.colors.N20,
            text: _theme.colors.N800,
            secondaryText: _theme.colors.N200
        }
    }), themeWithKeys = exports.themeWithKeys = function(maybeTheme, key, parentKey) {
        return parentKey ? maybeTheme && maybeTheme[parentKey] && maybeTheme[parentKey][key] ? maybeTheme : defaultTheme : maybeTheme && maybeTheme[key] ? maybeTheme : defaultTheme;
    };
    exports.getThemeStyle = function(maybeTheme, key, parentKey) {
        var theme = themeWithKeys(maybeTheme, key, parentKey);
        return parentKey ? theme[parentKey][key] : theme[key];
    };
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/theme");
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(14), _defineProperty3 = _interopRequireDefault(_defineProperty2), _extends2 = __webpack_require__(15), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(16), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _getDisplayName = __webpack_require__(17), _getDisplayName2 = _interopRequireDefault(_getDisplayName), _safeContextCall = __webpack_require__(18), _safeContextCall2 = _interopRequireDefault(_safeContextCall), _contextNamespace = __webpack_require__(19), withItemClick = function(WrappedItem) {
        var _class, _temp2;
        return _temp2 = _class = function(_Component) {
            function WithItemClick() {
                var _temp, _this, _ret;
                (0, _classCallCheck3.default)(this, WithItemClick);
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [ this ].concat(args))), 
                _this.callContextFn = (0, _safeContextCall2.default)(_this, _contextNamespace.clickManagerContext), 
                _this.shouldCloseAfterClick = function() {
                    return !_this.props.isDisabled && !_this.props.href;
                }, _this.handleClick = function(event) {
                    _this.props.onClick(event), _this.shouldCloseAfterClick() && _this.callContextFn("itemClicked");
                }, _this.handleKeyDown = function(event) {
                    "Space" !== event.key && "Enter" !== event.key || _this.handleClick(event);
                }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
            }
            return (0, _inherits3.default)(WithItemClick, _Component), WithItemClick.prototype.render = function() {
                var _props = this.props, children = _props.children, otherProps = (0, _objectWithoutProperties3.default)(_props, [ "children" ]);
                return _react2.default.createElement(WrappedItem, (0, _extends3.default)({}, otherProps, {
                    onClick: this.handleClick,
                    onKeyDown: this.handleKeyDown
                }), children);
            }, WithItemClick;
        }(_react.Component), _class.displayName = "WithItemClick(" + (0, _getDisplayName2.default)(WrappedItem) + ")", 
        _class.defaultProps = {
            onClick: function() {}
        }, _class.contextTypes = (0, _defineProperty3.default)({}, _contextNamespace.clickManagerContext, _propTypes2.default.object), 
        _temp2;
    };
    // We currently need to keep the dropdown open if an item with `href` is clicked, to avoid the
    // analytics package to track the href value without the event target disappearing. Without this
    // requirement, we could just use a native click event all the way up to DropdownMenuStateless,
    // and could get rid of this HOC and DropdownItemClickManager.
    exports.default = withItemClick;
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/objectWithoutProperties");
}, /* 17 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    // from https://facebook.github.io/react/docs/higher-order-components.html
    var getDisplayName = function(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    };
    exports.default = getDisplayName;
}, /* 18 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = function(// There are cases where the context is not available, such as when a dropdown item is used
    // inside @atlaskit/navigation. For this reason we have this helper function which safely calls
    // the context functions if they are available.
    instance, contextKey) {
        return function(fnToCall) {
            for (var _instance$context$con, _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
            return instance.context[contextKey] ? (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args) : null;
        };
    };
}, /* 19 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var prefix = function(key) {
        return "@atlaskit-private-do-not-use/dropdown-menu:" + key;
    };
    exports.focusManagerContext = prefix("focus-manager"), exports.selectionCacheContext = prefix("selection-cache"), 
    exports.selectionManagerContext = prefix("selection-manager"), exports.clickManagerContext = prefix("click-manager");
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(14), _defineProperty3 = _interopRequireDefault(_defineProperty2), _extends2 = __webpack_require__(15), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(16), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _reactDom = __webpack_require__(21), _reactDom2 = _interopRequireDefault(_reactDom), _uid = __webpack_require__(22), _uid2 = _interopRequireDefault(_uid), _getDisplayName = __webpack_require__(17), _getDisplayName2 = _interopRequireDefault(_getDisplayName), _safeContextCall = __webpack_require__(18), _safeContextCall2 = _interopRequireDefault(_safeContextCall), _contextNamespace = __webpack_require__(19), withItemFocus = function(WrappedComponent) {
        var _class, _temp2;
        return _temp2 = _class = function(_Component) {
            function WithItemFocus() {
                var _temp, _this, _ret;
                (0, _classCallCheck3.default)(this, WithItemFocus);
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [ this ].concat(args))), 
                _this.callContextFn = (0, _safeContextCall2.default)(_this, _contextNamespace.focusManagerContext), 
                _this.isFocusable = function() {
                    return !_this.props.isDisabled && !_this.props.isHidden;
                }, _this.handleFocus = function() {
                    _this.isFocusable() && _this.callContextFn("itemFocused", _this.contextId);
                }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
            }
            return (0, _inherits3.default)(WithItemFocus, _Component), WithItemFocus.prototype.componentDidMount = function() {
                this.isFocusable() && (this.contextId = (0, _uid2.default)(), // eslint-disable-next-line react/no-find-dom-node
                this.callContextFn("registerItem", this.contextId, _reactDom2.default.findDOMNode(this)));
            }, WithItemFocus.prototype.componentDidUpdate = function() {
                this.isFocusable() && // eslint-disable-next-line react/no-find-dom-node
                this.callContextFn("updateItem", this.contextId, _reactDom2.default.findDOMNode(this));
            }, WithItemFocus.prototype.componentWillUnmount = function() {
                this.isFocusable() && this.callContextFn("deregisterItem", this.contextId);
            }, WithItemFocus.prototype.render = function() {
                var _props = this.props, children = _props.children, otherProps = (0, _objectWithoutProperties3.default)(_props, [ "children" ]);
                return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({
                    onFocus: this.handleFocus,
                    role: "menuitem"
                }, otherProps), children);
            }, WithItemFocus;
        }(_react.Component), _class.displayName = "WithItemFocus(" + (0, _getDisplayName2.default)(WrappedComponent) + ")", 
        _class.propTypes = {
            /** Content to be displayed inside the item. Same as @atlaskit/item `children` prop. */
            children: _propTypes2.default.node,
            /** If true, the item appears greyed out and does not fire click events. */
            isDisabled: _propTypes2.default.bool,
            /** If true, the item is mounted but not rendered. */
            isHidden: _propTypes2.default.bool
        }, _class.contextTypes = (0, _defineProperty3.default)({}, _contextNamespace.focusManagerContext, _propTypes2.default.object), 
        _temp2;
    };
    exports.default = withItemFocus;
}, /* 21 */
/***/
function(module, exports) {
    module.exports = require("react-dom");
}, /* 22 */
/***/
function(module, exports) {
    module.exports = require("uid");
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(15), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(16), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _Item = __webpack_require__(24), _Item2 = _interopRequireDefault(_Item), _ItemParts = __webpack_require__(25), Item = function(_Component) {
        function Item(props) {
            (0, _classCallCheck3.default)(this, Item);
            // The type of element rendered at the root of render() can vary based on the `href`
            // and `linkComponent` props provided. We generate this component here to avoid re-
            // generating the component inside render(). This is for performance reasons, and also
            // allows us to avoid generating a new `ref` for the root element each render().
            var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
            return _this.setRef = function(ref) {
                _this.ref = ref;
            }, _this.href = function() {
                return _this.props.isDisabled ? null : _this.props.href;
            }, _this.rootComponent = (0, _Item2.default)({
                href: _this.href(),
                linkComponent: props.linkComponent
            }), _this;
        }
        // eslint-disable-next-line react/sort-comp
        return (0, _inherits3.default)(Item, _Component), Item.prototype.componentDidMount = function() {
            this.ref && this.props.autoFocus && this.ref.focus();
        }, Item.prototype.render = function() {
            var _this2 = this, _props = this.props, _onClick = _props.onClick, _onKeyDown = _props.onKeyDown, isCompact = _props.isCompact, isDisabled = _props.isDisabled, isDragging = _props.isDragging, isHidden = _props.isHidden, isSelected = _props.isSelected, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, role = _props.role, dnd = _props.dnd, otherProps = (0, 
            _objectWithoutProperties3.default)(_props, [ "onClick", "onKeyDown", "isCompact", "isDisabled", "isDragging", "isHidden", "isSelected", "onMouseEnter", "onMouseLeave", "role", "dnd" ]), Root = this.rootComponent, dragHandleProps = dnd && dnd.dragHandleProps || null, patchedEventHandlers = {
                onClick: function(event) {
                    var original = function() {
                        !isDisabled && _onClick && _onClick(event);
                    };
                    // Drag and drop has its own disabled mechansim
                    // So not checking for isDisabled
                    // if default is prevent - do not fire the onClick prop
                    return dragHandleProps && dragHandleProps.onClick ? (dragHandleProps.onClick(event), 
                    void (event.defaultPrevented || original())) : void original();
                },
                onMouseDown: function(event) {
                    dragHandleProps && dragHandleProps.onMouseDown && dragHandleProps.onMouseDown(event), 
                    // We want to prevent the item from getting focus when clicked
                    event.preventDefault();
                },
                onKeyDown: function(event) {
                    var original = function() {
                        !isDisabled && _onKeyDown && _onKeyDown(event);
                    };
                    // if default is prevent - do not fire other handlers
                    return dragHandleProps && dragHandleProps.onKeyDown ? (dragHandleProps.onKeyDown(event), 
                    void (event.defaultPrevented || isDragging || original())) : void original();
                }
            }, patchedInnerRef = function(ref) {
                _this2.setRef(ref), dnd && dnd.innerRef(ref);
            };
            return _react2.default.createElement(Root, (0, _extends3.default)({
                "aria-disabled": isDisabled,
                href: this.href(),
                isCompact: isCompact,
                isDisabled: isDisabled,
                isDragging: isDragging,
                isHidden: isHidden,
                isSelected: isSelected,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                role: role,
                tabIndex: isDisabled || isHidden || this.props.href ? null : 0,
                target: this.props.target,
                title: this.props.title,
                style: dnd ? dnd.draggableStyle : null,
                innerRef: patchedInnerRef
            }, dragHandleProps, patchedEventHandlers, otherProps), !!this.props.elemBefore && _react2.default.createElement(_ItemParts.Before, {
                isCompact: isCompact
            }, this.props.elemBefore), _react2.default.createElement(_ItemParts.ContentWrapper, null, _react2.default.createElement(_ItemParts.Content, {
                allowMultiline: this.props.shouldAllowMultiline
            }, this.props.children), !!this.props.description && _react2.default.createElement(_ItemParts.Description, {
                isCompact: this.props.isCompact,
                isDisabled: this.props.isDisabled
            }, this.props.description)), !!this.props.elemAfter && _react2.default.createElement(_ItemParts.After, {
                isCompact: isCompact
            }, this.props.elemAfter));
        }, Item;
    }(_react.Component);
    Item.propTypes = {
        /** Optional function to be used for rendering links. Receives `href` and possibly `target`
	    * as props. */
        linkComponent: _propTypes2.default.func,
        /** Main content to be shown inside the item. */
        children: _propTypes2.default.node,
        /** Secondary text to be shown underneath the main content. */
        description: _propTypes2.default.string,
        /** Drag and drop props provided by react-beautiful-dnd. Please do not use this unless
	    * using react-beautiful-dnd */
        dnd: _propTypes2.default.shape({
            draggableStyle: _propTypes2.default.object,
            dragHandleProps: _propTypes2.default.object,
            innerRef: _propTypes2.default.func
        }),
        /** Content to be shown after the main content. Shown to the right of content (or to the left
	    * in RTL mode). */
        elemAfter: _propTypes2.default.node,
        /** Content to be shown before the main content. Shown to the left of content (or to the right
	    * in RTL mode). */
        elemBefore: _propTypes2.default.node,
        /** Link that the user will be redirected to when the item is clicked. If omitted, a
	   *  non-hyperlink component will be rendered. */
        href: _propTypes2.default.string,
        /** Causes the item to be rendered with reduced spacing. */
        isCompact: _propTypes2.default.bool,
        /** Causes the item to appear in a disabled state and click behaviours will not be triggered. */
        isDisabled: _propTypes2.default.bool,
        /** Used to apply correct dragging styles when also using react-beautiful-dnd. */
        isDragging: _propTypes2.default.bool,
        /** Causes the item to still be rendered, but with `display: none` applied. */
        isHidden: _propTypes2.default.bool,
        /** Causes the item to appear with a persistent selected background state. */
        isSelected: _propTypes2.default.bool,
        /** Function to be called when the item is clicked, Receives the MouseEvent. */
        onClick: _propTypes2.default.func,
        /** Function to be called when the item is pressed with a keyboard,
	  * Receives the KeyboardEvent. */
        onKeyDown: _propTypes2.default.func,
        /** Standard onmouseenter event */
        onMouseEnter: _propTypes2.default.func,
        /** Standard onmouseleave event */
        onMouseLeave: _propTypes2.default.func,
        /** Allows the role attribute of the item to be altered from it's default of
	   *  `role="button"` */
        role: _propTypes2.default.string,
        /** Allows the `children` content to break onto a new line, rather than truncating the
	   *  content. */
        shouldAllowMultiline: _propTypes2.default.bool,
        /** Target frame for item `href` link to be aimed at. */
        target: _propTypes2.default.string,
        /** Standard browser title to be displayed on the item when hovered. */
        title: _propTypes2.default.string,
        /** Whether the Item should attempt to gain browser focus when mounted */
        autoFocus: _propTypes2.default.bool
    }, Item.defaultProps = {
        autoFocus: !1,
        description: "",
        isCompact: !1,
        isDisabled: !1,
        isHidden: !1,
        role: "button",
        shouldAllowMultiline: !1
    }, exports.default = Item;
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.ItemBase = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(9), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    &:focus {\n      color: ", ";\n    }\n  " ], [ "\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    &:focus {\n      color: ", ";\n    }\n  " ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    padding: ", "px ", "px ", "px ", "px;\n  " ], [ "\n    padding: ", "px ", "px ", "px ", "px;\n  " ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    height: ", "px;\n  " ], [ "\n    height: ", "px;\n  " ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      ", "\n      /* e200 but without zindex */\n      /* using the same colour for all themes */\n      box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n    " ], [ "\n      ", "\n      /* e200 but without zindex */\n      /* using the same colour for all themes */\n      box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n    " ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    &:focus {\n      box-shadow: 0 0 0 2px ", " inset;\n      text-decoration: none;\n    }\n  " ], [ "\n    &:focus {\n      box-shadow: 0 0 0 2px ", " inset;\n      text-decoration: none;\n    }\n  " ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      cursor: not-allowed;\n      ", "\n      ", "\n    " ], [ "\n      cursor: not-allowed;\n      ", "\n      ", "\n    " ]), _templateObject7 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      ", "\n\n      &:hover {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      ", "\n    " ], [ "\n      ", "\n\n      &:hover {\n        ", "\n      }\n\n      &:active {\n        ", "\n      }\n\n      ", "\n    " ]), _templateObject8 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    &:hover {\n      ", "\n    }\n\n    &:active {\n      ", "\n    }\n\n    ", "\n  " ], [ "\n    &:hover {\n      ", "\n    }\n\n    &:active {\n      ", "\n    }\n\n    ", "\n  " ]), _templateObject9 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  && {\n    align-items: center;\n    border-radius: ", "px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ", ";\n    flex: none;\n    ", "\n    ", "\n    ", "\n    ", "\n\n    &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n" ], [ "\n  && {\n    align-items: center;\n    border-radius: ", "px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ", ";\n    flex: none;\n    ", "\n    ", "\n    ", "\n    ", "\n\n    &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n" ]), _templateObject10 = (0, 
    _taggedTemplateLiteral3.default)([ "", "" ], [ "", "" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(12), _theme2 = __webpack_require__(11), getItemState = function(stateName) {
        return function(_ref) {
            var theme = _ref.theme, stateStyles = (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], stateName);
            return (0, _styledComponents.css)(_templateObject, stateStyles.background, stateStyles.text, stateStyles.text);
        };
    }, getPadding = function(_ref2) {
        var isCompact = _ref2.isCompact, theme = _ref2.theme, paddingKey = isCompact ? "compact" : "default", _getThemeStyle = (0, 
        _theme2.getThemeStyle)(theme[_theme2.themeNamespace], paddingKey, "padding"), _getThemeStyle$bottom = _getThemeStyle.bottom, bottom = void 0 === _getThemeStyle$bottom ? 0 : _getThemeStyle$bottom, _getThemeStyle$left = _getThemeStyle.left, left = void 0 === _getThemeStyle$left ? 0 : _getThemeStyle$left, _getThemeStyle$right = _getThemeStyle.right, right = void 0 === _getThemeStyle$right ? 0 : _getThemeStyle$right, _getThemeStyle$top = _getThemeStyle.top, top = void 0 === _getThemeStyle$top ? 0 : _getThemeStyle$top;
        return (0, _styledComponents.css)(_templateObject2, top, right, bottom, left);
    }, getHeightStyles = function(_ref3) {
        var isCompact = _ref3.isCompact, theme = _ref3.theme, heightKey = isCompact ? "compact" : "default", height = (0, 
        _theme2.getThemeStyle)(theme[_theme2.themeNamespace], heightKey, "height");
        return height ? (0, _styledComponents.css)(_templateObject3, height) : "";
    }, getInteractiveStyles = function(_ref4) {
        var theme = _ref4.theme, isDisabled = _ref4.isDisabled, isDragging = _ref4.isDragging, isSelected = _ref4.isSelected;
        if (isDragging) return (0, _styledComponents.css)(_templateObject4, getItemState("dragging"), _theme.colors.N60A, _theme.colors.N60A);
        var standardFocus = (0, _styledComponents.css)(_templateObject5, (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "outline", "focus"));
        return isDisabled ? (0, _styledComponents.css)(_templateObject6, getItemState("disabled"), standardFocus) : isSelected ? (0, 
        _styledComponents.css)(_templateObject7, getItemState("selected"), getItemState("hover"), getItemState("active"), standardFocus) : (0, 
        _styledComponents.css)(_templateObject8, getItemState("hover"), getItemState("active"), standardFocus);
    }, ItemBase = exports.ItemBase = function(_ref5) {
        var theme = _ref5.theme;
        return (0, _styledComponents.css)(_templateObject9, (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "borderRadius"), function(_ref6) {
            var isHidden = _ref6.isHidden;
            return isHidden ? "none" : "flex";
        }, getItemState("default"), getPadding, getInteractiveStyles, getHeightStyles);
    }, styledRootElement = function(_ref7) {
        var href = _ref7.href, linkComponent = _ref7.linkComponent;
        return href ? linkComponent ? (0, _styledComponents2.default)(linkComponent)(_templateObject10, ItemBase) : _styledComponents2.default.a(_templateObject10, ItemBase) : _styledComponents2.default.span(_templateObject10, ItemBase);
    };
    exports.default = styledRootElement;
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.Description = exports.Content = exports.ContentWrapper = exports.After = exports.Before = exports.InputWrapper = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(9), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  margin: 0 2px;\n" ], [ "\n  display: flex;\n  margin: 0 2px;\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n" ], [ "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    margin-right: ", "px;\n  " ], [ "\n    margin-right: ", "px;\n  " ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n" ], [ "\n  ", "\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    margin-left: ", "px;\n  " ], [ "\n    margin-left: ", "px;\n  " ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child { margin: 0; }\n" ], [ "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child { margin: 0; }\n" ]), _templateObject7 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ", ";\n  line-height: ", ";\n" ], [ "\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ", ";\n  line-height: ", ";\n" ]), _templateObject8 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      color: ", ";\n    " ], [ "\n      color: ", ";\n    " ]), _templateObject9 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    color: ", ";\n\n    // This detects hover on the grandparent. Saves us having to maintain isHovered\n    // state in the grandparent.\n    *:hover > * > & {\n      color: ", ";\n    }\n\n    *:active > * > & {\n      color: ", ";\n    }\n  " ], [ "\n    color: ", ";\n\n    // This detects hover on the grandparent. Saves us having to maintain isHovered\n    // state in the grandparent.\n    *:hover > * > & {\n      color: ", ";\n    }\n\n    *:active > * > & {\n      color: ", ";\n    }\n  " ]), _templateObject10 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    font-size: ", "px;\n    line-height: ", ";\n  " ], [ "\n    font-size: ", "px;\n    line-height: ", ";\n  " ]), _templateObject11 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n  ", "\n" ], [ "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n  ", "\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(12), _theme2 = __webpack_require__(11), BeforeAfterBase = (exports.InputWrapper = _styledComponents2.default.span(_templateObject), 
    _styledComponents2.default.span(_templateObject2)), getBeforeSpacing = function(_ref) {
        var isCompact = _ref.isCompact, theme = _ref.theme, spaceKey = isCompact ? "compact" : "default", space = (0, 
        _theme2.getThemeStyle)(theme[_theme2.themeNamespace], spaceKey, "beforeItemSpacing");
        return (0, _styledComponents.css)(_templateObject3, space);
    }, getAfterSpacing = (exports.Before = (0, _styledComponents2.default)(BeforeAfterBase)(_templateObject4, getBeforeSpacing), 
    function(_ref2) {
        var isCompact = _ref2.isCompact, theme = _ref2.theme, spaceKey = isCompact ? "compact" : "default", space = (0, 
        _theme2.getThemeStyle)(theme[_theme2.themeNamespace], spaceKey, "afterItemSpacing");
        return (0, _styledComponents.css)(_templateObject5, space);
    }), getColorStyle = (exports.After = (0, _styledComponents2.default)(BeforeAfterBase)(_templateObject4, getAfterSpacing), 
    exports.ContentWrapper = _styledComponents2.default.span(_templateObject6), exports.Content = _styledComponents2.default.span(_templateObject7, function(_ref3) {
        var allowMultiline = _ref3.allowMultiline;
        return allowMultiline ? "normal" : "nowrap";
    }, 16 / (0, _theme.fontSize)()), function(_ref4) {
        var isDisabled = _ref4.isDisabled, theme = _ref4.theme;
        return isDisabled ? (0, _styledComponents.css)(_templateObject8, (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "secondaryText", "disabled")) : (0, 
        _styledComponents.css)(_templateObject9, (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "secondaryText", "default"), function() {
            return (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "secondaryText", "hover");
        }, function() {
            return (0, _theme2.getThemeStyle)(theme[_theme2.themeNamespace], "secondaryText", "active");
        });
    }), getDescriptionFontStyles = function(_ref5) {
        var isCompact = _ref5.isCompact, descriptionFontSize = isCompact ? _theme2.compactSmallFontSize : _theme2.smallFontSize, lineHeight = isCompact ? _theme2.compactLineHeight : 14 / descriptionFontSize;
        return (0, _styledComponents.css)(_templateObject10, descriptionFontSize, lineHeight);
    };
    exports.Description = _styledComponents2.default.span(_templateObject11, getColorStyle, getDescriptionFontStyles);
} ]);


//////////////////
// WEBPACK FOOTER
// ../item/dist/bundle-cjs.js
// module id = 483
// module chunks = 0